import { Reducer } from "redux";
import { Action, ActionType } from "../../actions";
import { ProviderCredentialsEditorData } from "../../state/ProviderCredentials/EditorData";


const updateProviderCredentialsEditorData: Reducer<ProviderCredentialsEditorData> =
  (state: ProviderCredentialsEditorData = new ProviderCredentialsEditorData(), action: Action<ActionType, ProviderCredentialsEditorData>) => {
    switch (action.type) {
      case ActionType.PROVIDER_CREDENTIALS_EDITOR_DATA_RESET:
        return new ProviderCredentialsEditorData();
      case ActionType.PROVIDER_CREDENTIALS_EDITOR_DATA_FETCHED:
        return { ...state, providerCredentialsData: action.data };
      case ActionType.PROVIDER_CREDENTIALS_EDITOR_DATA_COPIED:
        return { ...state, providerCredentialsData: { ...action.data} };
      case ActionType.PROVIDER_CREDENTIALS_EDITOR_DATA_UPDATED:
        return { ...state, providerCredentialsData: { ...state.providerCredentialsData, ...action.data } };
      case ActionType.PROVIDER_CREDENTIALS_EDITOR_DATA_SAVED:
        return { ...state, readyToSave: false };
      case ActionType.PROVIDER_CREDENTIALS_EDITOR_DATA_VALIDATED:
        return { ...state, validation: action.data };
      case ActionType.PROVIDER_CREDENTIALS_EDITOR_DATA_GET_PROVIDER:
        return { ...state, providerCredentialsData: {provider: action.data}}
      default:
        return state;
    }
  };

export default updateProviderCredentialsEditorData;
